<template>
  <WebsiteCmsShell title="Detail Kategori Berita" subtitle="Periksa informasi kategori publikasi website" list-eyebrow="Detail data" list-title="Informasi kategori" list-description="Lihat data kategori atau lanjutkan ke halaman edit.">
    <template #list>
            <div class="row align-items-center">

              <!-- Profile Image -->
              <div class="col-md-4">
                <div class="d-flex justify-content-center align-items-center image-container">
                  <div style='height: 350px; width: 350px; position: relative'>
                    <img
                      class="image"
                      src="/images/appointment-splash.svg"
                      @load="onImageLoad()"
                    >
                  </div>
                </div>
              </div>

              <!-- Table Data -->
              <div
                class="col"
                v-if="imgLoaded"
              >
                <table class="table mb-3">
                  <tr>
                    <td style="width: 25%"><strong>Nama</strong></td>
                    <td>{{ data.name }}</td>
                  </tr>
                  <tr>
                    <td><strong>Deskripsi</strong></td>
                    <td>{{ data.description }}</td>
                  </tr>
                </table>

                <button
                  @click="$router.push({path: '/website/post-category/edit/' + data.id})"
                  class="btn mx-1 btn-success" v-if="btn"
                ><i class="far fa-fw fa-edit"></i> Edit</button>
                <button
                  @click="deleteData"
                  class="btn mx-1 btn-danger"
                  v-if="btn"
                ><i class="far fa-fw fa-trash-alt"></i> Hapus</button>
              </div>

            </div>
    </template>
  </WebsiteCmsShell>
</template>

<script>

import WebsiteCmsShell from "@/component/websites/WebsiteCmsShell.vue"
import module from '@/core/modules/CrudModule.js'
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module"

export default {

  data() {
    return {
      // Data
      data: {
        name: "",
        description: ""
      },
      // Other
      imgLoaded: true,
      // user access
      btn: true,
    }
  },

  components: {
    WebsiteCmsShell,
  },

  methods: {

    onImageLoad() {
      this.imgLoaded = true
    },

    async deleteData() {
      let result = await module.delete('website-post-categories/' + this.$route.params.id)
      // If Deleted
      if (result) {
        // Redirect To List
        this.$router.push('/website/post-category')
      }
    },

    async get() {
      this.data = await module.get('website-post-categories/' + this.$route.params.id)
      // If Data Not Found
      if (this.data == null) {
        // Redirect To List
        this.$router.push('/website/post-category')
      }
    },

    // setActiveButton(){
    //   let access_right_user = window.localStorage.getItem("access_right_display")
    //   let access_right = JSON.parse(access_right_user)

    //   let a
    //   for(a = 0; a < access_right.length; a++){
    //     if(access_right[a] == "1802"){
    //       this.btn = true
    //     }
    //   }
    // },

  },

  mounted() {
    // BreadCrumb
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Daftar Kategori Berita", route: "/website/post-category" },
      { title: "Detail Kategori Berita" },
    ])
    // Get Data
    this.get()
  },
}

</script>
